import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import pallet from '../../../layouts/pallet';
import { dataGridSx } from '../../common/styled/DataGrid';
import { BusTableProps } from '../types/busTypes';
import getBusColumns from '../utils/columns';
import { GridContainer } from '../styled';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const BusTable: React.FC<BusTableProps> = ({
  rows,
  loading,
  onUnlink,
  onEdit,
  onDelete,
  onGenerateQr
}) => {
  const columns = React.useMemo(
    () =>
      getBusColumns({
        onUnlink,
        onEdit,
        onDelete,
        onGenerateQr
      }),
    [onUnlink, onEdit, onDelete, onGenerateQr]
  );

  return (
    <GridContainer>
      <DataGrid
        rows={rows}
        getRowId={(row) => row.id}
        columns={columns}
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        disableRowSelectionOnClick
        loading={loading}
        initialState={{
          ...tableColumnUtils.DATA_GRID_INITIAL_STATE,
          columns: {
            columnVisibilityModel: { id: false }
          }
        }}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </GridContainer>
  );
};

export default BusTable;
